import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  OrderLinkFlowDeliveryPreferencesRequestType,
  OrderLinkFlowDeliveryPreferencesResponseType,
} from "@sellar-io/api-v2/types";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderLinkFlowDeliveryPreferences = (
  orderFlowToken: string | null,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OrderLinkFlowDeliveryPreferencesRequestType) =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "post",
        path: "order-link-flow/delivery-preferences",
        data,
        headers: {
          authorization: `Bearer ${orderFlowToken}`,
        },
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as OrderLinkFlowDeliveryPreferencesResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ServerStateKeys.OrderLinkFlowOrder, orderFlowToken],
      });
    },
  });
};
